import { render, staticRenderFns } from "./BlockLegend.vue?vue&type=template&id=3415c778"
import script from "./BlockLegend.vue?vue&type=script&lang=js"
export * from "./BlockLegend.vue?vue&type=script&lang=js"
import style0 from "./BlockLegend.vue?vue&type=style&index=0&id=3415c778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports